<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <el-select
      v-model="filters.CourseTypeId"
      placeholder="请选择类型"
      @change="onChangeSelect"
    >
      <el-option
        v-for="(item, index) in acitiviestypelist"
        :key="index"
        :label="item.Name"
        :value="item.Id"
      ></el-option>
    </el-select>

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="Id" label="ID"></el-table-column>
      <el-table-column
        prop="ActivityTypeName"
        label="活动分类"
        sortable
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="线下活动名称"
        sortable
      ></el-table-column>
      <el-table-column prop="ListImg" label="封面" sortable>
        <!-- 图片的显示 -->
        <template slot-scope="scope">
          <img :src="scope.row.ListImg" min-width="280" height="150" />
        </template>
      </el-table-column>
      <el-table-column
        prop="Address"
        label="活动地址"
        sortable
      ></el-table-column>
      <el-table-column
        prop="Maxmember"
        label="活动最大人数"
        sortable
      ></el-table-column>
      <el-table-column
        prop="NowMember"
        label="已报名人数"
        sortable
      ></el-table-column>
      <el-table-column prop="IsStick" label="是否置顶" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.IsStick === false ? "否" : "是" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="OrderSort" label="排序" sortable></el-table-column>
      <el-table-column prop="IsStick" label="状态" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.Status === 2 ? "发布" : "草稿" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="ApplyStartDateTime"
        label="报名开始时间"
        sortable
      ></el-table-column>
      <el-table-column
        prop="StartDateTime"
        label="活动开始时间"
        sortable
      ></el-table-column>
      <el-table-column
        prop="EndDateTime"
        label="活动结束时间"
        sortable
      ></el-table-column>
      <el-table-column label="操作" width align="center">
        <template slot-scope="scope">
          <span
            class="SpanList"
            @click="AutoQRCode(scope.row.IdentifierOne, scope.row.Name)"
            >查看二维码</span
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="15"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="90px"
        :rules="addFormRules"
        ref="editForm"
      >
        <el-form-item label="活动名称" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="活动分类" prop="ActivityTypeId">
          <el-select
            v-model="editForm.ActivityTypeId"
            placeholder="请选择活动分类"
          >
            <el-option
              v-for="(item, index) in acitiviestypelist"
              :key="index"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片" prop="ListImg">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img
              v-if="editForm.ListImg"
              :src="editForm.ListImg"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="简介" prop="Intro">
          <el-input type="textarea" v-model="editForm.Intro"></el-input>
        </el-form-item>
        <el-form-item label="活动地址" prop="Address">
          <el-input v-model="editForm.Address"></el-input>
        </el-form-item>
        <el-form-item label="支持人数" prop="Maxmember">
          <el-input v-model="editForm.Maxmember"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="OrderSort">
          <el-input v-model="editForm.OrderSort"></el-input>
        </el-form-item>
        <el-form-item label="报名时间">
          <el-date-picker
            v-model="editForm.ApplyStartDate"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <!-- <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="editForm.ApplyStartDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-time-picker
              type="fixed-time"
              placeholder="选择时间"
              v-model="editForm.ApplyStartTime"
              style="width: 100%"
              value-format="HH:mm:ss"
            ></el-time-picker>
          </el-col> -->
        </el-form-item>
        <el-form-item label="开始时间">
          <!-- <el-col :span="11"> -->
          <el-date-picker
            v-model="editForm.StartTime"
            type="datetime"
            placeholder="选择日期时间"
            @change="onChnageStartTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <!-- <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="editForm.StartDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker> -->
          <!-- </el-col> -->
          <!-- <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
           
            <el-time-picker
              type="fixed-time"
              placeholder="选择时间"
              v-model="editForm.StartTime"
              style="width: 100%"
              value-format="HH:mm:ss"
            ></el-time-picker>
          </el-col> -->
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="editForm.EndTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <!-- <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="editForm.EndDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-time-picker
              type="fixed-time"
              placeholder="选择时间"
              v-model="editForm.EndTime"
              style="width: 100%"
              value-format="HH:mm:ss"
            ></el-time-picker>
          </el-col> -->
        </el-form-item>
        <el-form-item label="是否置顶" prop="IsStick">
          <el-select v-model="editForm.IsStick" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in Sticklist"
              :label="item.Name"
              :value="item.IsStick"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否发布" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in Statuslist"
              :label="item.Name"
              :value="item.Status"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--使用编辑器
        -->

        <el-form-item label="活动介绍" prop="Notice">
          <div class="edit_container">
            <quill-editor
              v-model="editForm.Notice"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption"
              @ready="onEditorReady($event)"
            ></quill-editor>
          </div>
        </el-form-item>
        <el-form-item label="活动流程" prop="Detail">
          <div class="edit_container">
            <quill-editor
              v-model="editForm.Detail"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption"
              @ready="onEditorReady($event)"
            ></quill-editor>
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="90px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="活动名称" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="活动分类" prop="ActivityTypeId">
          <el-select
            v-model="addForm.ActivityTypeId"
            placeholder="请选择活动分类"
          >
            <el-option
              v-for="(item, index) in acitiviestypelist"
              :key="index"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片" prop="ListImg">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img v-if="addForm.ListImg" :src="addForm.ListImg" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="简介" prop="Intro">
          <el-input type="textarea" v-model="addForm.Intro"></el-input>
        </el-form-item>
        <el-form-item label="活动地址" prop="Address">
          <el-input v-model="addForm.Address"></el-input>
        </el-form-item>
        <el-form-item label="支持人数" prop="Maxmember">
          <el-input v-model="addForm.Maxmember"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="OrderSort">
          <el-input v-model="addForm.OrderSort"></el-input>
        </el-form-item>
        <el-form-item label="报名时间" prop="ApplyStartDate">
          <el-date-picker
            v-model="addForm.ApplyStartDate"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <!-- <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="editForm.ApplyStartDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-time-picker
              type="fixed-time"
              placeholder="选择时间"
              v-model="editForm.ApplyStartTime"
              style="width: 100%"
              value-format="HH:mm:ss"
            ></el-time-picker>
          </el-col> -->
        </el-form-item>
        <el-form-item label="开始时间" prop="StartTime">
          <!-- <el-col :span="11"> -->
          <el-date-picker
            v-model="addForm.StartTime"
            type="datetime"
            placeholder="选择日期时间"
            @change="onChnageStartTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <!-- <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="editForm.StartDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker> -->
          <!-- </el-col> -->
          <!-- <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
           
            <el-time-picker
              type="fixed-time"
              placeholder="选择时间"
              v-model="editForm.StartTime"
              style="width: 100%"
              value-format="HH:mm:ss"
            ></el-time-picker>
          </el-col> -->
        </el-form-item>
        <el-form-item label="结束时间" prop="EndDate">
          <el-date-picker
            v-model="addForm.EndDate"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <!-- <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="editForm.EndDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-time-picker
              type="fixed-time"
              placeholder="选择时间"
              v-model="editForm.EndTime"
              style="width: 100%"
              value-format="HH:mm:ss"
            ></el-time-picker>
          </el-col> -->
        </el-form-item>
        <el-form-item label="是否置顶" prop="IsStick">
          <el-select v-model="addForm.IsStick" placeholder="请选择状态">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否发布" prop="Status">
          <el-select v-model="addForm.Status" placeholder="请选择状态">
            <el-option label="发布" value="2"></el-option>
            <el-option label="草稿" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!--使用编辑器
        -->
        <el-form-item label="活动介绍" prop="Notice">
          <div class="edit_container">
            <quill-editor
              v-model="addForm.Notice"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption"
              @ready="onEditorReady($event)"
            ></quill-editor>
          </div>
        </el-form-item>
        <el-form-item label="活动流程" prop="Detail">
          <div class="edit_container">
            <quill-editor
              v-model="addForm.Detail"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption"
              @ready="onEditorReady($event)"
            ></quill-editor>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--二维码界面-->
    <el-dialog
      title="二维码"
      :visible.sync="QRCodeVisible"
      :close-on-click-modal="false"
    >
      <div>
        <vue-qr
          :logoSrc="imageUrl"
          logoScale="0.2"
          :text="IdentifierOne"
          :size="QRCodeSize"
        ></vue-qr>
      </div>
      <el-form label-width="90px">
        <el-form-item label="活动名称">
          <el-input readonly="" v-model="ActicityName"></el-input>
        </el-form-item>
        <el-form-item label="二维码大小">
          <el-button @click="QRCodeSize = 200">200</el-button>
          <el-button @click="QRCodeSize = 300">300</el-button>
          <el-button @click="QRCodeSize = 400">400</el-button>
          <el-button @click="QRCodeSize = 500">500</el-button>
          <el-button @click="QRCodeSize = 600">600</el-button>
          <el-button @click="QRCodeSize = 700">700</el-button>
          <el-button @click="QRCodeSize = 800">800</el-button>
          <el-button @click="QRCodeSize = 900">900</el-button>
          <el-button @click="QRCodeSize = 1000">1000</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  getactivitiespagelist,
  UploadImg,
  activitiessingle,
  activitiesadd,
  activitiesdelete,
  activitiesedit,
  getactivitytype,
  AddRecordInfo,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

import vueQr from "vue-qr";

export default {
  components: { Toolbar, quillEditor, vueQr },
  data() {
    return {
      QRCodeSize: 200,
      ActicityName: "123",
      IdentifierOne: "123",
      imageUrl: "../static/images/icon.png",
      QRCodeVisible: false,
      editorOption: {},
      dialogVisible: false,
      formLabelWidth: "80px",
      limitNum: 1,
      buttonList: [],
      acitiviestypelist: [],
      Sticklist: [
        { Id: 1, Name: "是", IsStick: true },
        { Id: 2, Name: "否", IsStick: false },
      ],
      Statuslist: [
        { Id: 2, Name: "发布", Status: 2 },
        { Id: 1, Name: "草稿", Status: 1 },
      ],
      currentRow: null,
      filters: {
        name: "",
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,

      //编辑界面数据
      editForm: {
        Id: 0,
        Name: "",
        ListImg: "",
        ApplyStartDate: new Date(),
        ApplyStartTime: new Date(),
        StartDate: new Date(),
        StartTime: new Date(),
        EndDate: new Date(),
        EndTime: new Date(),
        Intro: "",
        Notice: "",
        Maxmember: 0,
        Address: "",
        IsStick: false,
        Status: 1,
        ActivityTypeId: 0,
        OrderSort: 0,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        ActivityTypeId: [
          { required: true, message: "请输入活动分类", trigger: "change" },
        ],
        CourseTypeId: [
          { required: true, message: "活动类型", trigger: "blur" },
        ],
        Intro: [{ required: true, message: "简介", trigger: "blur" }],
        Address: [{ required: true, message: "活动地址", trigger: "blur" }],
        Maxmember: [{ required: true, message: "支持人数", trigger: "blur" }],
        ListImg: [{ required: true, message: "图片", trigger: "change" }],
        Detail: [{ required: true, message: "详情", trigger: "blur" }],
        ApplyStartDate: [
          { required: true, message: "报名时间", trigger: "blur" },
        ],
        StartTime: [{ required: true, message: "开始时间", trigger: "blur" }],
        EndDate: [{ required: true, message: "结束时间", trigger: "blur" }],
        Notice: [{ required: true, message: "活动流程", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        Name: "",
        ListImg: "",
        ApplyStartDate: "",
        ApplyStartTime: null,
        StartDate: "",
        StartTime: null,
        EndDate: "",
        EndTime: null,
        Intro: "",
        Notice: "",
        Maxmember: 0,
        Address: "",
        IsStick: "false",
        Status: "1",
        ActivityTypeId: "",
        OrderSort: 0,
      },
    };
  },
  methods: {
    async AddRecordInfo(action, description) {
      var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );
      let res = await AddRecordInfo({
        userName: user.uRealName + "-" + user.uLoginName,
        action: action,
        description: description,
      });
    },
    AutoQRCode(IdentifierOne, Name) {
      this.QRCodeVisible = true;
      this.IdentifierOne = IdentifierOne;
      this.ActicityName = Name;
      // new QRCode(this.$refs.qrCodeDiv, {
      //   text: 'Vue实现生成二维码！',
      //   width: 200,
      //   height: 200,
      //   colorDark: "#333333", //二维码颜色
      //   colorLight: "#ffffff", //二维码背景色
      //   correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      // })
    },
    onChnageStartTime(e) {
      console.log(e);
    },
    onChangeSelect(e) {
      this.filters.CourseTypeId = e;
      this.getLists();
    },
    onEditorReady(editor) {},
    // 上传文件之前的钩子
    handleAvatarSuccess(res, file) {
      this.addForm.ListImg = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "警告",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
        });
      }
      let size = file.size / 1024 / 1024 / 2;
      if (size > 2) {
        this.$notify.warning({
          title: "警告",
          message: "图片大小必须小于2M",
        });
      }
    },
    // 上传文件
    uploadFile(item) {
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      UploadImg(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        this.addForm.ListImg = response.data.response;
        console.log("filename", this.addForm.ListImg);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    //获取课程类型
    getactivitytypelist() {
      getactivitytype().then((res) => {
        console.log(res);
        this.acitiviestypelist = res.data.response;
        // this.acitiviestypelist.push({ Id: 0, Name: "--请选择活动类型--" });
        this.acitiviestypelist.reverse();
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters.name = item.search;
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatbcontent: function (row, column) {
      return row.bcontent ? row.bcontent.substring(20) : "N/A";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLists();
    },
    getModules() {
      this.getLists();
      console.log("getModules");
    },
    //获取列表
    getLists() {
      let para = {
        PageIndex: this.page,
        PageSize: 10,
        Name: this.filters.name,
        ActivitiesTypeId: this.filters.CourseTypeId,
      };
      this.listLoading = true;
      getactivitiespagelist(para).then((res) => {
        console.log(res);
        this.AddRecordInfo(
          "查询",
          "活动管理-线下活动管理-查看线下活动管理列表"
        );

        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          activitiesdelete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.AddRecordInfo(
                "删除",
                "活动管理-线下活动管理-删除线下活动管理列表"
              );

              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getLists();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      activitiessingle({ Id: row.Id }).then((res) => {
        if (res.data.success) {
          this.getactivitytypelist();
          //   ApplyStartTime: null,
          // StartDate: null,
          // StartTime: null,
          // EndDate: null,
          // EndTime: null,
          this.editForm = res.data.response.data;
          this.editForm.EndTime = res.data.response.data.EndDateTime;
          this.editForm.StartTime = res.data.response.data.StartDateTime;
          this.editForm.ApplyStartDate =
            res.data.response.data.ApplyStartDateTime;
          // {
          //   Id: res.data.response.data.Id,
          //   Name: "",
          //   ListImg: "",
          //   ApplyStartDate: null,
          //   ApplyStartTime: null,
          //   StartDate: null,
          //   StartTime: null,
          //   EndDate: null,
          //   EndTime: null,
          //   Intro: "",
          //   Notice: "",
          //   Maxmember: 0,
          //   Address: "",
          //   IsStick: 0,
          //   Status: 0,
          //   ActivityTypeId: 0,
          // };

          this.editFormVisible = true;
        }
      });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Name: "",
        ListImg: "",
        ApplyStartDateTime: null,
        StartDateTime: null,
        EndDateTime: null,
        Intro: "",
        Notice: "",
        Maxmember: 0,
        Address: "",
        IsStick: "false",
        Status: "1",
        ActivityTypeId: "",
        OrderSort: 0,
      };
      this.getactivitytypelist();
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.ModifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ApplyStartDateTime = this.editForm.ApplyStartDate;
            para.StartDateTime = this.editForm.StartTime;
            para.EndDateTime = this.editForm.EndDate;
            // console.log(para);
            activitiesedit(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getLists();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            console.log(this.addForm);
            let para = Object.assign({}, this.addForm);
            para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ModifyTime = para.CreateTime;

            para.ApplyStartDateTime = this.addForm.ApplyStartDate;
            para.StartDateTime = this.addForm.StartTime;
            para.EndDateTime = this.addForm.EndDate;

            var user = JSON.parse(window.localStorage.user);
            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            activitiesadd(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.AddRecordInfo(
                  "新增",
                  "活动管理-线下活动管理-新增线下活动管理列表"
                );

                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getLists();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  mounted() {
    this.getLists();

    this.getactivitytypelist();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
<style lang='less'>
#qqq {
  background-color: #111;
  width: 300px;
  height: 300px;
  margin: 0 auto; /*水平居中*/
  position: relative;
}

#qrCode {
  display: inline-block;
  margin: 0 auto; /*水平居中*/
  position: relative;
  top: 15%;

  img {
    width: 200px;
    height: 200px;
    background-color: #fff; //设置白色背景色
    padding: 6px; // 利用padding的特性，挤出白边
  }
}
</style>
